import ApiService from "../../ApiService";

const PracticeService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/practice/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    updateUnitResult: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/practice/updateunitresult", vo, successCallback, failureCallback);
    },
    reviewUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/practice/reviewunit", vo, successCallback, failureCallback);
    },
    restart: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/practice/restart", vo, successCallback, failureCallback);
    },
    complete: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/practice/complete", vo, successCallback, failureCallback);
    },
};

export default PracticeService;
